import { useEffect, useState } from 'react';
import logger from '../../../utils/logger';

const DEFAULT_AVATAR = '../avatar.png';

/**
 * Loads avatar + display metadata for every user id appearing in comments/replies.
 */
export function useCommentListAvatars(comments, getUserDetailsById) {
  const [userAvatars, setUserAvatars] = useState({});

  useEffect(() => {
    const fetchAvatars = async () => {
      const uniqueUserIds = [
        ...new Set(
          comments.flatMap((comment) => [
            comment.userId,
            ...(comment.replies || []).map((reply) => reply.userId),
          ])
        ),
      ];

      const avatars = {};

      for (const userId of uniqueUserIds) {
        try {
          const userDetails = await getUserDetailsById(userId);
          avatars[userId] = {
            avatar: userDetails?.avatar || DEFAULT_AVATAR,
            displayName:
              userDetails?.displayName ||
              userDetails?.userName ||
              'Unknown User',
            handle: userDetails?.handle || null,
          };
        } catch (error) {
          logger.error('Error fetching user details:', error);
          avatars[userId] = {
            avatar: DEFAULT_AVATAR,
            displayName: 'Unknown User',
            handle: null,
          };
        }
      }

      setUserAvatars(avatars);
    };

    if (comments && comments.length > 0) {
      fetchAvatars();
    }
  }, [comments, getUserDetailsById]);

  return { userAvatars, defaultAvatar: DEFAULT_AVATAR };
}
